import { AnimatePresence, motion } from "framer-motion";
import { FC } from "react";
import { ErrorMessageProps } from "./interfaces";

export const ErrorMessage: FC<ErrorMessageProps> = ({ message, mode }) => {
  return (
    <AnimatePresence>
      {message && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.3 }}
          className="flex items-center mt-1 text-xs text-red-500"
        >
          <span>{mode ? `${message} (${mode})` : message}</span>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
